export default __webpack_public_path__ + "static/media/DJ Izinkan Kurasakan PerhatianmuThomas Arya feat Iqa Nizam.aa4d2168.mp3";